import pt_PT from './pt_PT.json';
import en_GB from './en_GB.json';

const messages = {
  'pt-PT': pt_PT,
  'en-GB': en_GB,
};

export default messages;
